import styled from "styled-components";
import { Colors } from "../../constants";
import { Button } from "@mui/material";

const LineItem = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const LineItemsSecondary = styled(LineItem)`
  margin-top: 24px;
  gap: 24px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 1;
  gap: 8px;
`;

export const Title = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Value = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
`;

export const DefaultButton = styled(Button)`
  && {
    padding: 8px 22px;
    text-transform: none;
    font-family: "Work Sans"; 
    font-size: 15px; 
    font-weight: 500;
    gap: 8px;
    background-color: var(--luft-primary);
    color: #FFF;
    
    &:hover {
      background-color: ${Colors.PRIMARY_LIGHT_DARK};
    }
}
`;
